"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactGridLayout = _interopRequireDefault(require("react-grid-layout"));
var _reactRouterDom = require("react-router-dom");
var _Background = _interopRequireDefault(require("./Background"));
var _CellView = _interopRequireDefault(require("./CellView"));
var _utils = require("../utils");
var _Loader = _interopRequireDefault(require("./Loader"));
var _LevelStatus = _interopRequireDefault(require("./LevelStatus"));
var _FontSizeSelector = _interopRequireDefault(require("./FontSizeSelector"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Page = /*#__PURE__*/function (_react$default$Compon) {
  function Page() {
    _classCallCheck(this, Page);
    return _callSuper(this, Page, arguments);
  }
  _inherits(Page, _react$default$Compon);
  return _createClass(Page, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.langChanged)(this.props, nextProps) || (0, _utils.pageChanged)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        page = _this$props.page,
        project = _this$props.project,
        width = _this$props.width,
        changeLocale = _this$props.changeLocale,
        uriTransformer = _this$props.uriTransformer,
        displayLanguageModal = _this$props.displayLanguageModal,
        logEvent = _this$props.logEvent,
        visible = _this$props.visible,
        screenType = _this$props.screenType,
        showProduct = _this$props.showProduct,
        currentSize = _this$props.currentSize,
        setCurrentSize = _this$props.setCurrentSize,
        adjustFontSize = _this$props.adjustFontSize;
      var nbCols = 4 * screenType.x_dimension;
      var minRows = 4 * screenType.y_dimension;
      var dimensionSize = 10;
      var rowHeight = width / nbCols;
      var totalHeight = width * screenType.y_dimension / screenType.x_dimension;
      var cells = page.cells;
      var layout = [];
      var _iterator = _createForOfIteratorHelper(cells),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cell = _step.value;
          cell.x = cell.coordinates[screenType.id].x;
          cell.y = cell.coordinates[screenType.id].y;
          cell.width = cell.coordinates[screenType.id].width;
          cell.height = cell.coordinates[screenType.id].height;
          layout.push({
            i: cell.id,
            x: cell.x,
            y: cell.y,
            w: cell.width,
            h: cell.height,
            static: true
          });
          var cellHeight = (cell.y + cell.height) * rowHeight;
          if (cellHeight > totalHeight) totalHeight = cellHeight;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return /*#__PURE__*/_react.default.createElement(_Background.default, {
        visible: visible,
        value: page,
        uriTransformer: uriTransformer,
        height: "".concat(totalHeight, "px"),
        isFixed: "true"
      }, /*#__PURE__*/_react.default.createElement(_reactGridLayout.default, {
        autoSize: false,
        style: {
          width: "".concat(width, "px"),
          position: 'absolute'
        },
        layout: layout,
        margin: [0, 0],
        cols: nbCols,
        rowHeight: rowHeight,
        width: width,
        isDraggable: false,
        isResizable: false
      }, cells.map(function (cell) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: cell.id
        }, /*#__PURE__*/_react.default.createElement(_CellView.default, {
          page: page,
          logEvent: logEvent,
          displayLanguageModal: displayLanguageModal,
          showProduct: showProduct,
          project: project,
          defaultLanguage: project.primary_language_code,
          cell: cell,
          width: width,
          gridSize: rowHeight,
          linkFromPageId: function linkFromPageId(pageId, children, props) {
            return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
              to: "/page/".concat(pageId),
              onClick: function onClick() {
                logEvent('click', {
                  cellId: cell.id,
                  pageId: page.id,
                  toPageId: pageId
                });
              }
            }, props), children);
          },
          uriTransformer: uriTransformer,
          changeLocale: changeLocale,
          style: {
            overflow: 'hidden'
          }
        }));
      })), project.main_page_id === page.id && screenType.name == 'tablette' && /*#__PURE__*/_react.default.createElement(_LevelStatus.default, {
        project: project,
        key: 'level-status'
      }));
    }
  }]);
}(_react.default.Component);
_defineProperty(Page, "whyDidYouRender", true);
var PageWrapper = function PageWrapper(props) {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.default, null)
  }, /*#__PURE__*/_react.default.createElement(Page, props));
};
var _default = exports.default = PageWrapper;